import { render } from '@react-email/components'

import { MemberInvitation } from 'ms-email/emails/templates/MemberInvitation'
import { getOwner } from 'ms-email/utils/get-owner'
import { getOwnerName } from 'ms-email/utils/get-owner-name'

import { send as ses } from './send'

export const send = async ({ workspace }, to) => {
  const owner = getOwner(workspace)
  const fullname = getOwnerName(owner)
  const subject = `Action required: ${fullname} invited you to join their workspace on Mapstack`
  const content = await render(<MemberInvitation workspace={workspace} />)
  return await ses(subject, content, to)
}
